import Vue from 'vue';
import Vuex from 'vuex';

import getters from './getters';

import {list} from '@/api/front.js'

Vue.use(Vuex);

const context = require.context('./modules', false, /\.js$/);

const modules = context.keys().reduce((module, filePath) => {
  const fileName = filePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  const value = context(filePath);
  module[fileName] = value.default;
  return module;
}, {});

export default new Vuex.Store({
  modules,
  state: {
    list: [],
  },
  mutations: {
    setList(state, reslist) {
      state.list=reslist
    },

  },
  actions: {
    getList(context) {
      list().then(res=>{
        context.commit('setList',res)
      })
    }
  },
  getters: {
    gameList: state=>{return state.list}
  },
  'modules': {
    getters
  }
});
